import { Validators } from '@angular/forms'

export function getUserInfoFormControls() {
    const { required, email, minLength, maxLength } = Validators
    return {
        firstName: ['', required],
        lastName: ['', required],
        email: ['', [required, email]],
        password: [
            '',
            [
                required,
                minLength(8),
                maxLength(32),
                Validators.pattern(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).+$/,
                ),
            ],
        ],
        phone: [''],
    }
}
